// src/components/SettingsButton.jsx
import React from 'react';
import styles from './Header.module.css';
import SettingIcon from './SettingIcon';

const SettingsButton = ({ onClick }) => {
  return (
    <div className={styles.menuItem}>
      <button className={styles.iconButton} onClick={onClick} aria-label="Настройки">
        <SettingIcon className={styles.icon} />
      </button>
    </div>
  );
};

export default SettingsButton;
